import { render, staticRenderFns } from "./Page1.vue?vue&type=template&id=438899b1"
import script from "./Page1.vue?vue&type=script&lang=js"
export * from "./Page1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports